import axiosInstance from "utils/axiosConfig";
import { FAST_API_BASE_URL } from "constants";

export const completePendingOAuth = async (userToken) => {
  const raw = sessionStorage.getItem("pending_oauth");

  if (!raw) return null;

  let params;
  try {
    params = JSON.parse(raw);
  } catch {
    sessionStorage.removeItem("pending_oauth");
    return { success: false, message: "Invalid pending OAuth session" };
  }

  try {
    const res = await axiosInstance.post(
      `${FAST_API_BASE_URL}/api/oauth/approve`,
      { user_token: userToken, ...params }
    );

    if (res.data?.redirect_url) {
      sessionStorage.removeItem("pending_oauth");
      return { success: true, redirectUrl: res.data.redirect_url };
    }

    return { success: false, message: "OAuth approval failed. No redirect URL." };

  } catch (err) {
    return {
      success: false,
      message:
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        err?.response?.data?.messages?.[0] ||
        "OAuth approval failed",
    };
  }
};